// material
import {

    Card,
    Table,
    TableRow,
    TableBody,
    TableCell,
    TableHead,
    TableContainer,
    Container,
} from '@material-ui/core';
// utils
import { RootState, useDispatch, useSelector } from 'redux/store';
import { useEffect } from 'react';
import { getRouteBankBO } from 'redux/slices/routeBankBO';
import HeaderBreadcrumbs from 'components/HeaderBreadcrumbs';
import Page from 'components/Page';
import { getDeliveryOptions } from 'redux/slices/deliveryOptions';
import useLocales from 'hooks/useLocales';
// ----------------------------------------------------------------------

export default function DeliveryOptions() {
    const { translate } = useLocales();
    const dispatch = useDispatch();
    const { deliveryOptions } = useSelector(
        (state: RootState) => state.deliveryOptionsBO
    );


    useEffect(() => {
        dispatch(getDeliveryOptions());
    }, [dispatch]);


    return (
        <>  <Page title="Delivery options">
            <Container maxWidth="xl">

                <HeaderBreadcrumbs
                    heading={translate(`dashboard.${"Delivery options"}`)}
                    links={[
                        // { name: 'Amount', href: PATH_DASHBOARD.user.root },
                        // { name: 'Delivery Options', href: PATH_DASHBOARD.user.root },
                    ]}
                />
                <Card sx={{ pb: 3 }}>
                    <TableContainer sx={{ minWidth: 720 }}>
                        <Table>
                            <TableHead>
                                <TableRow>
                                    <TableCell>Delivery option Id</TableCell>
                                    <TableCell>Delivery option code</TableCell>
                                    <TableCell>Delivery option name</TableCell>
                                </TableRow>
                            </TableHead>
                            {deliveryOptions !== null &&
                                <TableBody>
                                    {deliveryOptions.map((row) => (
                                        <TableRow key={row.deliveryOptionId}>
                                            <TableCell>{row.deliveryOptionId}</TableCell>
                                            <TableCell>{row.deliveryOptionCode}</TableCell>
                                            <TableCell>{row.deliveryOptionName}</TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>}
                        </Table>

                    </TableContainer>
                </Card>
            </Container>
        </Page></>
    );
}